"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _icon = _interopRequireDefault(require("../icon"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  return {
    input: {
      display: 'flex',
      padding: 0,
      minWidth: 240,
      // A good default for most labels
      height: 'auto'
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      // Adjust for MUI label
      marginTop: theme.spacing(2) + 5
    },
    chip: {
      margin: "".concat(theme.spacing(1), "px ").concat(theme.spacing(0.25), "px")
    },
    chipFocused: {
      backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    noOptionsMessage: {
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px")
    },
    singleValue: {
      fontSize: theme.typography.subtitle1.fontSize
    },
    // placeholder: {
    //   position: 'absolute',
    //   left: 2,
    //   fontSize: theme.typography.subtitle1.fontSize
    // },
    paper: {
      position: 'absolute',
      zIndex: 1,
      // Adjust for MUI label
      // marginTop: theme.spacing.unit * 7
      marginTop: theme.spacing(1)
    },
    root: {
      // Allow for help icon to be placed on right of field
      display: 'inline-flex'
    },
    fullWidth: {
      width: '100%'
    },
    disabled: {
      color: theme.palette.text.secondary
    }
  };
};

function NoOptionsMessage(props) {
  return /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({
    color: "textSecondary",
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}

function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["inputRef"]);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    ref: inputRef
  }, props));
}

function Control(props) {
  var optionalProps = {};

  if (props.selectProps.fullWidth) {
    optionalProps.fullWidth = true;
  }

  return /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({}, optionalProps, {
    InputProps: {
      inputComponent,
      inputProps: _objectSpread({
        className: props.selectProps.classes.input,
        inputRef: props.innerRef,
        children: props.children,
        // We need to specify the aria-label so that this element is the one that receives focus
        // for the target field label
        'aria-label': props.selectProps.ariaLabel
      }, props.innerProps)
    }
  }, props.selectProps.textFieldProps));
}

function Option(props) {
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, (0, _extends2.default)({
    buttonRef: props.innerRef,
    selected: props.isFocused,
    component: "div",
    style: {
      fontWeight: props.isSelected ? 500 : 400
    }
  }, props.innerProps), props.children);
} // Note: kept in case we want to implement the placeholder in the future
// function Placeholder(props) {
//   return (
//     <Typography
//       color="textSecondary"
//       className={props.selectProps.classes.placeholder}
//       {...props.innerProps}
//     >
//       {props.children}
//     </Typography>
//   );
// }


function SingleValue(props) {
  return /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({
    className: (0, _classnames.default)(props.selectProps.classes.singleValue, props.selectProps.isDisabled ? props.selectProps.classes.disabled : null)
  }, props.innerProps), props.children);
}

function ValueContainer(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.selectProps.classes.valueContainer
  }, props.children);
}

function MultiValue(props) {
  return /*#__PURE__*/_react.default.createElement(_Chip.default, {
    tabIndex: -1,
    label: props.children,
    className: (0, _classnames.default)(props.selectProps.classes.chip, {
      [props.selectProps.classes.chipFocused]: props.isFocused,
      [props.selectProps.classes.disabled]: props.selectProps.isDisabled
    }),
    onDelete: props.removeProps.onClick,
    deleteIcon: /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "Cancel",
      "aria-label": "Remove",
      role: "button",
      "aria-hidden": "false"
    })
  });
}

function Menu(props) {
  return /*#__PURE__*/_react.default.createElement(_Paper.default, (0, _extends2.default)({
    square: true,
    className: props.selectProps.classes.paper
  }, props.innerProps), props.children);
}

var components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  // Placeholder,
  SingleValue,
  ValueContainer
};

var AutoCompleteSelect = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AutoCompleteSelect, _React$Component);

  var _super = _createSuper(AutoCompleteSelect);

  function AutoCompleteSelect() {
    (0, _classCallCheck2.default)(this, AutoCompleteSelect);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(AutoCompleteSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          options = _this$props.options,
          isClearable = _this$props.isClearable,
          placeholder = _this$props.placeholder,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          onInputChange = _this$props.onInputChange,
          value = _this$props.value,
          isDisabled = _this$props.isDisabled,
          fullWidth = _this$props.fullWidth,
          isMulti = _this$props.isMulti,
          id = _this$props.id;
      var selectStyles = {
        dropdownIndicator: function dropdownIndicator(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            cursor: 'pointer'
          });
        },
        clearIndicator: function clearIndicator(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            cursor: 'pointer'
          });
        },
        // Needed so that the menu appears above any dialog windows
        menuPortal: function menuPortal(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            zIndex: 2000
          });
        }
      };
      return /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
        id: id,
        className: (0, _classnames.default)(classes.root, fullWidth && classes.fullWidth),
        classes: classes,
        styles: selectStyles,
        options: options,
        components: components,
        value: value,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        onInputChange: onInputChange,
        placeholder: placeholder,
        isClearable: isClearable,
        isDisabled: isDisabled,
        fullWidth: fullWidth,
        isMulti: isMulti // Needed so that the menu is not clipped by the app's root level overflow:hidden or when it
        // appears in a dialog window
        ,
        menuPortalTarget: document.body // Specify ariaLabel instead of aria-label as it is the Control that needs to render the
        // aria-label
        ,
        ariaLabel: this.props['aria-label']
      });
    }
  }]);
  return AutoCompleteSelect;
}(_react.default.Component);

var _default = (0, _styles.withStyles)(styles)(AutoCompleteSelect);

exports.default = _default;